export function TranslationsDeutsch() 
{
   return [
      {"id": "Actions", "value": "Aktionen"},
      {"id": "Access key", "value": "Zugangsschlüssel"},
      {"id": "Access token", "value": "Zugangstoken"},
      {"id": "Account", "value": "Account"},
      {"id": "Account ID", "value": "Account-ID"},
      {"id": "Account URL", "value": "Account-URL"},
      {"id": "Actions on incoming call", "value": "Aktionen bei eingehenden Anruf"},
      {"id": "Add a custom integration", "value": "Benutzerdefinierte Integration hinzufügen"},
      {"id": "Add line","value":"Zeile hinzufügen"}, 
      {"id": "Add variable","value":"Variable hinzufügen"}, 
      {"id": "Add new integration", "value": "Neue Integration hinzufügen"},
      {"id": "Add new script", "value": "Neues Skript hinzufügen"},
      {"id": "API private key", "value": "Privater API-Schlüssel"},
      {"id": "API public key", "value": "Öffentlicher API-Schlüssel"},
      {"id": "API key", "value": "API-Schlüssel"},
      {"id": "API secret", "value": "API-Geheimnis"},
      {"id": "API URL", "value": "API-URL"},
      {"id": "App token", "value": "App-Token"},
      {"id": "Application", "value": "Anwendung"},
      {"id": "$Application connection token received succesfully", "value": "$Anwendungstoken erfolgreich empfangen"},
      {"id": "Application token", "value": "Anwendungstoken"},
      {"id": "Auto-execute", "value": "Automatisch ausführen"},
      {"id": "Automatic synchronization disabled", "value": "Automatische Synchronisierung deaktiviert"},
      {"id": "Automatic synchronization in", "value": "Automatische Synchronisierung in"},
      {"id": "Automatically synchronize every day", "value": "Täglich automatisch synchronisieren"},
      {"id": "Automatically synchronize every week", "value": "Wöchentlich automatisch synchronisieren"},
      {"id": "BACK", "value": "ZURÜCK"},
      {"id": "Call fields", "value": "Anruffelder"},
      {"id": "Call notification", "value": "Anrufbenachrichtigung"},
      {"id": "Caller name", "value": "Anrufername"},
      {"id": "Caller number", "value": "Anrufernummer"},
      {"id": "Can be modified from computer", "value": "Kann vom Computer aus bearbeitet werden"},
      {"id": "Cancel", "value": "Abbrechen"},
      {"id": "cannot be configured in the Webconfigurator because the integration is client-based", "value": "kann im Webkonfigurator nicht konfiguriert werden, da die Integration clientbasiert ist"},
      {"id": "cannot be configured in the Webconfigurator because the integration requires manual field configuration", "value": "kann im Webkonfigurator nicht konfiguriert werden, da die Integration eine manuelle Feldkonfiguration erfordert"},
      {"id": "Check settings", "value": "Einstellungen überprüfen"},
      {"id": "Checking CRM settings", "value": "CRM-Einstellungen werden überprüft"},
      {"id": "Choose an integration template", "value": "Integrationsvorlage auswählen"}, 	
      {"id": "Choose how you want to link to this application's recognition", "value": "Wählen Sie, wie Sie diese Anwendung mit der Ekennung verknüpfen möchten"},
      {"id": "Choose CRM", "value": "CRM auswählen"},  
      {"id": "Client call notification", "value": "Client-Anrufbenachrichtigung"},
      {"id": "Client ID", "value": "Client-ID"},
      {"id": "Client secret", "value": "Client-Geheimnis"},
      {"id": "Cluster", "value": "Cluster"},
      {"id": "Company Id", "value": "Unternehmens-ID"},
      {"id": "Configure", "value": "Konfigurieren"},
      {"id": "Configure incoming call", "value": "Eingehenden Anruf konfigurieren"},
      {"id": "Configure the $DatasourceName connection", "value": "Konfigurieren Sie die $DatasourceName-Verbindung"},
      {"id": "Configure the action you want to perform", "value": "Konfigurieren Sie die Aktion, die Sie ausführen möchten"},
      {"id": "Configure the information you want the client to show when a caller is recognized from this set", "value": "Informationen festlegen, die beim Erkennen eines Anrufers vom Client angezeigt werden solle"},
      {"id": "Configure the recognition fields", "value": "Erkennungsfelder konfigurieren"},
      {"id": "Configure your call notification","value":"Anrufbenachrichtigung konfigurieren"}, 
      {"id": "Connect", "value": "Verbinden"},
      {"id": "Country code", "value": "Ländercode"},
      {"id": "CRM configuration", "value": "CRM-Konfiguration"},
      {"id": "Current set: <count> phone number records", "value": "Aktuelles Set: <count> Telefonnummernaufzeichnungen"},
      {"id": "Custom phone fields", "value": "Benutzerdefinierte Telefonfelder"},
      {"id": "Database", "value": "Datenbank"},
      {"id": "Database country code", "value": "Ländercode der Datenbank"},
      {"id": "Database ID", "value": "Datenbank-ID"},
      {"id": "days", "value": "Tage"},
      {"id": "<days> days ago", "value": "vor <days> Tage(n)"},
      {"id": "Ddi name", "value": "DDI-Name"},
      {"id": "Ddi number", "value": "DDI-Nummer"},
      {"id": "Delete", "value": "Löschen"},
      {"id": "Device name", "value": "Gerätename"},
      {"id": "Device number", "value": "Gerätenummer"},	  
      {"id": "Disable", "value": "Deaktivieren"},
      {"id": "Do you really want to remove this integration?","value":"Möchten Sie diese Integration wirklich entfernen?"},
      {"id": "Do you really want to remove this script?","value":"Möchten Sie dieses Skript wirklich entfernen?"},
      {"id": "Domain", "value": "Domäne"},
      {"id": "Done", "value": "Fertig"},
      {"id": "Edit","value":"Bearbeiten"},  
      {"id": "Editing not available in web app","value":"Bearbeiten in der Web-Anwendung nicht verfügbar"},
      {"id": "Enable", "value": "Aktivieren"},
      {"id": "Enter the call field values to test the script with","value":"Geben Sie die Anruffeldwerte ein, um das Skript zu testen mit"}, 
      {"id": "<empty line>", "value": "<leere Zeile>"},
      {"id": "Enter the import country code", "value": "Geben Sie den Ländercode für den Import ein"},
      {"id": "Execute script", "value": "Skript ausführen"},
      {"id": "Failed to update the integration", "value": "Das Aktualisieren der Integration ist fehlgeschlagen"},
      {"id": "Finish", "value": "Abschließen"},
      {"id": "Header","value":"Kopfzeile"}, 
      {"id": "here", "value": "hier"},
      {"id": "Home","value":"Home"},
      {"id": "hours", "value": "Stunde"},
      {"id": "<hours> hours ago", "value": "vor <hours> Stunde(n)"},
      {"id": "Include accounts", "value": "Konten einbeziehen"},
      {"id": "Include contacts", "value": "Kontakte einbeziehen"},
      {"id": "Include employees", "value": "Mitarbeiter einbeziehen"},
      {"id": "Include companies", "value": "Unternehmen einbeziehen"},
      {"id": "Include leads", "value": "Leads einbeziehen"},
      {"id": "Include organizations", "value": "Organisationen einbeziehen"},
      {"id": "Include people", "value": "Personen einbeziehen"},
      {"id": "Include users", "value": "Benutzer einbeziehen"},
      {"id": "Incoming call","value":"Eingehender Anruf"},   
      {"id": "InSite URL", "value": "InSite-URL"},	  
      {"id": "Integrations", "value": "Integrationen"},
      {"id": "Integrations created with the desktop configurator can only be changed with the desktop configurator from the same computer.", "value": "Mit dem Desktop-Konfigurator erstellte Integrationen können nur auf demselben Computer mit dem Desktop-Konfigurator geändert werden."},
      {"id": "just now", "value": "soeben"},
      {"id": "Key", "value": "Schlüssel"},
      {"id": "Language", "value": "Sprache"},
      {"id": "Line","value":"Zeile"}, 
      {"id": "Loading...", "value": "Lädt..."},
      {"id": "Location info", "value": "Standortinformationen"},
      {"id": "minute", "value": "Minute"},
      {"id": "minute ago", "value": "vor einer Minute"},
      {"id": "minutes", "value": "Minuten"},
      {"id": "<minutes> minutes ago", "value": "vor <minutes> Minuten"},
      {"id": "My Custom Script", "value": "Mein benutzerdefiniertes Skript"},
      {"id": "Next", "value": "Weiter"},
      {"id": "Next synchronization could not be determined", "value": "Die nächste Synchronisierung konnte nicht bestimmt werden"},
      {"id": "No", "value": "Nein"},
      {"id": "No recognition has been configured", "value": "Keine Erkennung konfiguriert"},
      {"id": "No scripts have been configured", "value": "Keine Skripte konfiguriert"},
      {"id": "No settings are required. Click Next to continue", "value": "Keine Einstellungen erforderlich. Klicken Sie auf 'Weiter', um fortzufahren"},
      {"id": "Not synchronized yet", "value": "Noch nicht synchronisiert"},
      {"id": "OK", "value": "OK"},
      {"id": "Only synchronize manually", "value": "Nur manuell synchronisieren"},
      {"id": "Open application", "value": "Anwendung öffnen"},
      {"id": "Open webpage", "value": "Webseite öffnen"},
      {"id": "Or, if your application is not in the list", "value": "Oder, wenn Ihre Anwendung nicht in der Liste ist"},
      {"id": "Organization ID", "value": "Organisations-ID"},
      {"id": "Organization number", "value": "Organisationsnummer"},
      {"id": "Participant number", "value": "Teilnehmernummer"},
      {"id": "Password", "value": "Passwort"},
      {"id": "Perform an action in application", "value": "Aktion in der Anwendung ausführen"},
      {"id": "phone number records", "value": "Telefonnummernaufzeichnungen"},
      {"id": "Please download the Desktop Configurator", "value": "Laden Sie den Desktop-Konfigurator herunter"},
      {"id": "predefined script", "value": "vordefiniertes Skript"},
      {"id": "Preview", "value": "Vorschau"},
      {"id": "Preview incoming call", "value": "Vorschau eingehender Anruf"},
      {"id": "Profit Services URL", "value": "Profit Services URL"},
      {"id": "Recognition", "value": "Erkennung"},
      {"id": "Recognition fields", "value": "Erkennungsfelder"},
      {"id": "Recognition from", "value": "Erkennung von"},
      {"id": "Reference", "value": "Referenz"},
      {"id": "Region", "value": "Region"},
      {"id": "Remove this line","value":"Diese Zeile entfernen"},  
      {"id": "Requests per minute", "value": "Anfragen pro Minute"},
      {"id": "Review", "value": "Überprüfen"},
      {"id": "Review your integration", "value": "Überprüfen Sie Ihre Integrationen"},
      {"id": "FINISH", "value": "ABSCHLIESSEN"},
      {"id": "NEXT", "value": "WEITER"},
      {"id": "Sandbox account", "value": "Sandbox-Konto"},
      {"id": "Security token", "value": "Sicherheitstoken"},
      {"id": "Screenpop URL", "value": "Screenpop-URL"},
      {"id": "Script name", "value": "Skriptname"},
      {"id": "Script settings", "value": "Skripteinstellungen"},
      {"id": "Scripts", "value": "Skripte"},
      {"id": "Secret", "value": "Geheimnis"},
      {"id": "Secret key", "value": "Geheimer Schlüssel"},
      {"id": "Select how the data should be synchronized", "value": "Wählen Sie, wie die Daten synchronisiert werden sollen"},
      {"id": "Select your FileVine login", "value": "Wählen Sie Ihre FileVine-Anmeldung"},
      {"id": "Service URL", "value": "Dienst-URL"},
      {"id": "Sign out", "value": "Abmelden"},
      {"id": "Signed in as", "value": "Angemeldet als"},
      {"id": "Site", "value": "Seite"},
      {"id": "Software key","value":"Softwareschlüssel"},
      {"id": "Sorry", "value": "Entschuldigung"},
      {"id": "Source info", "value": "Quelleninformationen"},
      {"id": "Subdomain", "value": "Subdomain"},
      {"id": "Synchronization info", "value": "Synchronisationsinformationen"},
      {"id": "Sync now", "value": "Jetzt synchronisieren"},
      {"id": "System name", "value": "Systemname"},
      {"id": "Tenant", "value": "Mandant"},
      {"id": "Test script", "value": "Testskript"},
      {"id": "This application uses live search and does not need synchronization", "value": "Diese Anwendung verwendet die Live-Suche und benötigt keine Synchronisierung"},
      {"id": "The server will automatically execute script", "value": "Der Server führt das Skript automatisch aus"},
      {"id": "This integration is disabled", "value": "Diese Integration ist deaktiviert"},
      {"id": "This recognition is disabled", "value": "Diese Erkennung ist deaktiviert"},
      {"id": "This script is disabled", "value": "Dieses Skript ist deaktiviert"},
      {"id": "Token", "value": "Token"},
      {"id": "Token XML", "value": "Token XML"},
      {"id": "Unavailable in the Webconfigurator", "value": "Im Webkonfigurator nicht verfügbar"},
      {"id": "unknown type", "value": "unbekannter Typ"},
      {"id": "URL", "value": "URL"},
      {"id": "Use a team domain", "value": "Team-Domain verwenden"},
      {"id": "User", "value": "Benutzer"},
      {"id": "Username", "value": "Benutzername"},
      {"id": "Waiting for OAUTH verification", "value": "Warte auf OAUTH-Verifizierung"},
      {"id": "Webpage", "value": "Webseite"},
      {"id": "Web service username", "value": "Webservice-Benutzername"},
      {"id": "Web service password", "value": "Webservice-Passwort"},
      {"id": "WebService URL", "value": "WebService-URL"},
      {"id": "Welcome to the <branding_product> Webconfigurator for CRM integration", "value": "Willkommen beim <branding_product> Webkonfigurator für CRM-Integration"},
      {"id": "with caption", "value": "mit Titel"},
      {"id": "With this tool you can manage your CRM integrations", "value": "Mit diesem Tool können Sie Ihre CRM-Integrationen verwalten"},
      {"id": "Yes", "value": "Ja"},
      {"id": "Your organization", "value": "Ihre Organisation"}
    ]  
}
